export default __webpack_public_path__ + "static/media/maritime-industry.5ef54307.jpg";